import {
    MEMBERSHIP_USERDEFINEDFIELDS_LOADING,
    MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS,
    MEMBERSHIP_USERDEFINEDFIELDS_RESET,
    MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR,
    UPDATE_MEMBER_USERDEFINEDFIELD,
    UPDATE_MEMBERSHIP_USERDEFINEDFIELD_RENEW,
    UPDATE_USERDEFINEDFIELDS_MEMBER_ONEDIT_WHEN_CLICK_CANCEL_BUTTON,
    UPDATE_USERDEFINEDFIELDS_MEMBER_ON_SAVE

} from "../actions/actionMembershipUserDefinedFeilds";
import { UDFs } from 'helpers';
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "membershipUdfs";
const sessionKey2 = "updatemembersudfonrenew";


const initialState = {
    membershipUdfs: loadState(sessionKey1, []),
    loading: false,
    membershipUDFsError: '',
    updateMemberRecordsOnRenew: loadState(sessionKey2, false)
};

function reducerMembershipUserDefinedFields(state = initialState, action) {

    switch (action.type) {

        case MEMBERSHIP_USERDEFINEDFIELDS_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS: {

            let membershipsUdfs = JSON.parse(JSON.stringify(action.payload));

            membershipsUdfs = membershipsUdfs.filter(x => x.UDFCategories).map(membershipTypes => {

                membershipTypes.UDFCategories.map(udfCategories => {

                    let udfCat = { ...udfCategories };
                    udfCategories.UserDefinedFields = [];

                    if (udfCat.UserDefinedFields && udfCat.UserDefinedFields.length > 0) {
                        udfCat.UserDefinedFields.map(UDF => {

                            UDF.UDFID = Math.floor(100000 + Math.random() * 900000);
                            UDF.Value = '';
                            UDF.Users = [];
                            udfCategories.UserDefinedFields.push(UDF);
                        });
                    }
                });

                return membershipTypes;
            });


            saveState(sessionKey1, membershipsUdfs);
            saveState(sessionKey2, false);

            return {
                ...state,
                loading: false,
                updateMemberRecordsOnRenew: false,
                membershipUdfs: membershipsUdfs,
                membershipUDFsError: ''
            };
        }

        case UPDATE_MEMBER_USERDEFINEDFIELD: {

            let membershipsUdfs = JSON.parse(JSON.stringify(state.membershipUdfs));
            let membershipType = membershipsUdfs.find(x => x.MembershipTypeID === action.payload.membershipTypeID);

            membershipType.UDFCategories = membershipType.UDFCategories.map(udfCategories => {

                udfCategories.UserDefinedFields.filter(x => x.UDFID === action.payload.udfID).map(udf => {

                    if (udf.Users && udf.Users.length > -1 && udf.Users.filter(x => x.userID === action.payload.userNo).length == 0) {
                        let u = { userID: action.payload.userNo, userUDFValue: action.payload.value };
                        udf.Users.push(u)
                    }
                    else if (udf.Users && udf.Users.length > -1 && udf.Users.filter(x => x.userID === action.payload.userNo).length > 0) {
                        let u = udf.Users.find(x => x.userID == action.payload.userNo);

                        if (action.payload.isEdit && u.previousValue === undefined) {
                            u.isEdit = true;
                            u.previousValue = u.userUDFValue;
                        }

                        u.userUDFValue = action.payload.value;
                        udf.Users = udf.Users.filter(x => x.userID !== action.payload.userNo);

                        udf.Users.push(u)
                    }
                });

                return udfCategories;
            });

            membershipsUdfs = membershipsUdfs.filter(x => x.MembershipTypeID !== action.payload.membershipTypeID);
            membershipsUdfs.push(membershipType);

            saveState(sessionKey1, membershipsUdfs);

            return {
                ...state,
                loading: false,
                membershipUdfs: membershipsUdfs,
                membershipUDFsError: ''
            };
        }



        case UPDATE_MEMBERSHIP_USERDEFINEDFIELD_RENEW: {

            let membershipsUdfs = JSON.parse(JSON.stringify(state.membershipUdfs));
            let membershipPackage = JSON.parse(JSON.stringify(action.payload.membershipPackage));
            let customerUdfs = JSON.parse(JSON.stringify(action.payload.customerUdfs));

            membershipsUdfs = UDFs.UpdateMembershipUDFsWithCustomerUDFValue(membershipPackage, membershipsUdfs, customerUdfs);

            saveState(sessionKey1, membershipsUdfs);
            saveState(sessionKey2, true);

            return {
                ...state,
                loading: false,
                updateMemberRecordsOnRenew: true,
                membershipUdfs: membershipsUdfs,
                membershipUDFsError: ''
            }
        }

        case MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR: {

            saveState(sessionKey1, action.payload);
            saveState(sessionKey2, false);

            return {
                ...state,
                loading: false,
                updateMemberRecordsOnRenew: false,
                membershipUDFsError: action.error
            }
        }

        case MEMBERSHIP_USERDEFINEDFIELDS_RESET: {

            saveState(sessionKey1, []);
            saveState(sessionKey2, false);

            return {
                ...state,
                loading: false,
                updateMemberRecordsOnRenew: false,
                membershipUdfs: [],
                membershipUDFsError: ''
            };
        }

        case UPDATE_USERDEFINEDFIELDS_MEMBER_ONEDIT_WHEN_CLICK_CANCEL_BUTTON: {

            let membershipsUdfs = JSON.parse(JSON.stringify(state.membershipUdfs));
            let membershipType = membershipsUdfs.find(x => x.MembershipTypeID === action.payload.membershipTypeID);


            if (membershipType && membershipType.UDFCategories && membershipType.UDFCategories.length > 0) {
                membershipType.UDFCategories = membershipType.UDFCategories.map(udfCategories => {

                    udfCategories.UserDefinedFields.map(udf => {

                        if (udf.Users && udf.Users.length > -1 && udf.Users.filter(x => x.userID === action.payload.userNo && x.isEdit).length > 0) {
                            if (udf.IsRequired === false ||
                                (udf.IsRequired === true && ((udf.Picklist && udf.Picklist.length > 0) || udf.UDFType === "Decimal" || udf.UDFType === "Text" || udf.UDFType === "Date"))) {

                                let u = udf.Users.find(x => x.userID == action.payload.userNo && x.isEdit);

                                if (u) {
                                    u.userUDFValue = u.previousValue;
                                    udf.Users = udf.Users.filter(x => x.userID !== action.payload.userNo);
                                    udf.Users.push(u)
                                }
                            }
                        }
                    });

                    return udfCategories;
                });
            }


            if (membershipType) {
                membershipsUdfs = membershipsUdfs.filter(x => x.MembershipTypeID !== action.payload.membershipTypeID);
                membershipsUdfs.push(membershipType);

                saveState(sessionKey1, membershipsUdfs);
            }


            return {
                ...state,
                loading: false,
                membershipUdfs: membershipsUdfs,
                membershipUDFsError: ''
            };
        }

        case UPDATE_USERDEFINEDFIELDS_MEMBER_ON_SAVE: {

            let membershipsUdfs = JSON.parse(JSON.stringify(state.membershipUdfs));
            let membershipType = membershipsUdfs.find(x => x.MembershipTypeID === action.payload.membershipTypeID);


            if (membershipType && membershipType.UDFCategories && membershipType.UDFCategories.length > 0) {
                membershipType.UDFCategories = membershipType.UDFCategories.map(udfCategories => {

                    udfCategories.UserDefinedFields.map(udf => {

                        if (udf.Users && udf.Users.length > -1 && udf.Users.filter(x => x.userID === action.payload.userNo && x.isEdit).length > 0) {

                            let u = udf.Users.find(x => x.userID == action.payload.userNo && x.isEdit);

                            if (u) {
                                u.previousValue = undefined;
                                u.isEdit = false;
                                udf.Users = udf.Users.filter(x => x.userID !== action.payload.userNo);
                                udf.Users.push(u)
                            }
                        }

                    });

                    return udfCategories;
                });
            }


            if (membershipType) {
                membershipsUdfs = membershipsUdfs.filter(x => x.MembershipTypeID !== action.payload.membershipTypeID);
                membershipsUdfs.push(membershipType);

                saveState(sessionKey1, membershipsUdfs);
            }


            return {
                ...state,
                loading: false,
                membershipUdfs: membershipsUdfs,
                membershipUDFsError: ''
            };
        }

        default: {
            return state;
        }
    }
}

export default reducerMembershipUserDefinedFields;
